<template>
	<div
			class="v-input v-text-field theme--light"
			:class="{
				'v-input--is-focused': focused,
			}"
	>
		<div class="v-input__control">
			<div class="v-input__slot">
				<div class="v-text-field__slot">
					<label
							aria-hidden="true"
							class="v-label theme--light"
							style="left: 0px; right: auto; position: absolute;"
							:class="{
								'v-label--active': focused || filled,
								'primary--text': focused,
								'error--text': highlight_error,
							}"
					>{{ label }}</label>

					<slot></slot>
				</div>
			</div>
			<div class="v-text-field__details">
				<div class="v-messages theme--light">
					<div class="v-messages__wrapper"
						 :class="{ 'error--text': highlight_error }"
					>
						{{ errorText }}
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import _ from 'lodash';
	import {EventBus} from './../includes/EventBus';

	export default {
		name: "StyledTextField",

		props: {
			name: {
				type: String,
				required: true,
			},
			watchId: {
				type: String,
				default: '',
			},
			focusedClasses: {
				type: String,
				default: '',
			},
			filledClasses: {
				type: String,
				default: '',
			},
			label: {
				type: String,
				default: '',
			},
			errorText: {
				type: String,
				default: '',
			},
			hasError: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				observer: null,
				focused: false,
				filled: false,
				highlight_error: false,
			}
		},

		methods: {
			onClassChange(class_attr_value) {
				const self = this;
				const class_list = class_attr_value.split(' ');
				const focused_classes = self.focusedClasses.split(' ');
				const filled_classes = self.filledClasses.split(' ');

				self.focused = _.intersection(focused_classes, class_list).length > 0;
				self.filled = _.intersection(filled_classes, class_list).length > 0;
			},
		},

		watch: {
			hasError(value) {
				this.highlight_error = value;
			},

			focused(value) {
				if (value) {
					this.highlight_error = false;
					EventBus.$emit('error-dismissed', this.name);
				}
			}
		},

		mounted() {
			this.observer = new MutationObserver(mutations => {
				for (const m of mutations) {
					const newValue = m.target.getAttribute(m.attributeName);
					this.$nextTick(() => {
						this.onClassChange(newValue, m.oldValue);
					});
				}
			});

			this.observer.observe(document.getElementById(this.watchId), {
				attributes: true,
				attributeOldValue: true,
				attributeFilter: ['class'],
			});
		},
		beforeDestroy() {
			this.observer.disconnect();
		},
	}
</script>

<style scoped>

</style>